/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SpeakerContractQuery = {
    readonly _children: {
        readonly items: ReadonlyArray<{
            readonly _children?: {
                readonly items: ReadonlyArray<{
                    readonly metaTitle?: string | null;
                    readonly title?: string;
                    readonly content?: string | null;
                    readonly pageName?: string;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "SpeakerContractQuery";
};
export type SpeakerContractQuery$data = SpeakerContractQuery;
export type SpeakerContractQuery$key = {
    readonly " $data"?: SpeakerContractQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"SpeakerContractQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpeakerContractQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PublishedContentConnection",
      "kind": "LinkedField",
      "name": "_children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublishedContentConnection",
                  "kind": "LinkedField",
                  "name": "_children",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "metaTitle",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "title",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "content",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "pageName",
                                  "storageKey": null
                                }
                              ],
                              "type": "SimplePagePublishedContent",
                              "abstractKey": null
                            }
                          ],
                          "type": "ContentPagePublishedContent",
                          "abstractKey": "__isContentPagePublishedContent"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "FormPagePublishedContent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
(node as any).hash = '4526b3e6a53a0e1e87bc4d29e8824165';
export default node;
